import data from './attrs/data'
import methods from './attrs/methods'
import mounted from './attrs/mounted'
import draggable from 'vuedraggable'

export default {
    name: 'FrequentlyAskedQuestionsList',
    data,
    methods,
    mounted,
    components: {
        draggable
    }
}
